/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.22.0
 */

import { useEffect } from 'react';
import type { FC } from 'react';

import { useFormikContext } from 'formik';
import { useSelector } from 'react-redux';

import FormFieldInput from '../../form/components/FormFieldInput';
import FormFieldInputPhone from '../../form/components/FormFieldInputPhone';
import { makeSelectEdmOperatorConnectionTranslation, makeSelectTranslationCommon } from '../../internationalization/intSelectors';
import { EEdmDeliveryInfoFields } from '../constants';
import type { IAddEdmConnectionForm } from '../types';

interface IProps {
    allowEmailEdit?: boolean;
    allowPersonNameEdit?: boolean;
    allowPhoneNumberEdit?: boolean;
};

export const EdmResponsibleContact: FC<IProps> = (
    { allowEmailEdit = true, allowPersonNameEdit = true, allowPhoneNumberEdit = true },
) => {
    const { start: tConnectionStart } = useSelector(makeSelectEdmOperatorConnectionTranslation());
    const tCommon = useSelector(makeSelectTranslationCommon());

    const { errors, touched, validateForm } = useFormikContext<IAddEdmConnectionForm>();

    useEffect(() => {
        validateForm();
    }, [validateForm]);

    return (
        <>
            {allowPersonNameEdit && <FormFieldInput
                dataName='responsible-contact-name'
                hideValidation={true}
                hintMessage={(touched.name && errors.name) ? errors.name : ''}
                label={tConnectionStart.fields.name.label}
                name={EEdmDeliveryInfoFields.name}
                placeholder={tConnectionStart.fields.name.placeholder}
                required={true}
            />}
            {allowPhoneNumberEdit && <FormFieldInputPhone
                dataName='responsible-contact-phone'
                hideValidation={true}
                hintMessage={(touched.phone && errors.phone) ? errors.phone : ''}
                label={tConnectionStart.fields.phone.label}
                mask={tCommon.phoneInput.mask}
                name={EEdmDeliveryInfoFields.phone}
                placeholder={tConnectionStart.fields.phone.placeholder}
                required={true}
            />}
            {allowEmailEdit && <FormFieldInput
                dataName='responsible-contact-email'
                hideValidation={true}
                hintMessage={(touched.email && errors.email) ? errors.email : ''}
                label={tConnectionStart.fields.email.label}
                name={EEdmDeliveryInfoFields.email}
                placeholder={tConnectionStart.fields.email.placeholder}
                required={true}
            />}
        </>
    );
};
